module.exports = __webpack_public_path__ + "static/img/login-main-logo.eb5d336f.svg";